export enum TeachersTabSortKeyEnum {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'mobilePhone',
  GROUPS = 'groups',
  STATUS = 'status'
}

export enum ChildrenTabSortKeyEnum {
  NAME = 'name',
  BIRTHDAY = 'birthday',
  PARENTS = 'parents',
  GROUPS = 'groups',
  STATUS = 'status'
}
export enum ParentsTabSortKeyEnum {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  GROUPS = 'groups',
  CHILDREN = 'children',
  STATUS = 'status'
}
